<template>
   <v-dialog v-model="dlgedit" width="800" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="member-edit-dialog">
         <v-toolbar dark flat class="member-edit-toolbar">
            <v-btn icon dark @click="closeEdit">
               <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit Membership</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
               <v-btn dark text tile @click="approvemember" v-if="(editeditem) && (editeditem.memberstatus === 1) && !isCorporateUpgradePending">
                  <v-icon left>mdi-check-circle</v-icon>
                  Approve Membership
               </v-btn>
               <!-- <v-btn dark text tile @click="approveCorporateUpgrade" v-if="isCorporateUpgradePending">
                  <v-icon left>mdi-account-check</v-icon>
                  Approve Upgrade
               </v-btn>
               <v-btn dark text tile @click="rejectCorporateUpgrade" v-if="isCorporateUpgradePending">
                  <v-icon left>mdi-account-cancel</v-icon>
                  Reject Upgrade
               </v-btn> -->
               <v-btn dark text tile @click="openCorporateInfo" v-if="editeditem && editeditem.userid">
                  <v-icon left>mdi-account-arrow-up</v-icon>
                  Corporate Info
               </v-btn>
               <!-- <v-btn dark text tile @click="notifyDecline" v-if="editeditem && editeditem.userid">
                  <v-icon left>mdi-email-remove</v-icon>
                  Notify Decline
               </v-btn>
               <v-btn dark text tile @click="notifyIncomplete" v-if="editeditem && editeditem.userid">
                  <v-icon left>mdi-email-alert</v-icon>
                  Notify Incomplete
               </v-btn> -->
               <v-btn dark text tile @click="updatemember" :loading="savingMember" :disabled="savingMember">
                  <v-icon left>mdi-content-save</v-icon>
                  Save
               </v-btn>

            </v-toolbar-items>
         </v-toolbar>
         <v-tabs v-model="tab" fixed-tabs dark class="member-edit-tabs">
            <v-tab key="T1">
               General
            </v-tab>
            <v-tab key="T2">
               Details
            </v-tab>
            <v-tab key="T3">
               Qualification
            </v-tab>
            <v-tab key="T4" v-if="(editeditem) ? (editeditem.membertype !== 'STU') : false">
               Employment
            </v-tab>
            <v-tab key="T5" v-if="(editeditem) ? (editeditem.membertype === 'COR') : false">
               Corporate Experience
            </v-tab>
            <v-tab key="T6">
               Declaration
            </v-tab>
            <v-tab key="T7">
               Payments
            </v-tab>
         </v-tabs>
         <v-tabs-items v-model="tab">
            <v-tab-item key="T1">
               <div class="member-edit-page">
                  <div class="member-editor-hero">
                     <div class="hero-main">
                        <v-avatar size="72" class="hero-avatar">
                           <v-img :src="previewphoto || '/images/miplogo-300x300.png'" :alt="formmodel.sectdetails.fullname || 'Member'"></v-img>
                        </v-avatar>
                        <div class="hero-copy">
                           <div class="overline hero-overline">Membership Profile</div>
                           <h2>{{ formmodel.sectdetails.fullname || 'Member record' }}</h2>
                           <div class="hero-subline">
                              <span>{{ formmodelgeneral.memberid || 'Member ID not assigned' }}</span>
                              <span>{{ formmodel.sectdetails.contactemail || '-' }}</span>
                              <span>{{ formmodel.sectdetails.contactmobile || '-' }}</span>
                           </div>
                           <div class="hero-chips">
                              <v-chip small color="white" text-color="primary">{{ selectedMemberTypeLabel }}</v-chip>
                              <v-chip small :color="selectedStatusColor" text-color="white">{{ selectedStatusLabel }}</v-chip>
                              <v-chip small outlined color="white">{{ lpbmDisplay }}</v-chip>
                           </div>
                        </div>
                     </div>
                     <div class="hero-actions">
                        <v-btn outlined dark @click="tab = 1">
                           <v-icon left small>mdi-account-edit-outline</v-icon>
                           Edit Details
                        </v-btn>
                        <v-btn color="white" light @click="updatemember" :loading="savingMember" :disabled="savingMember">
                           <v-icon left small color="primary">mdi-content-save-outline</v-icon>
                           Save Changes
                        </v-btn>
                     </div>
                  </div>

                  <v-alert v-if="editeditem && editeditem.applcorpstatus" text color="blue" class="upgrade-info-panel">
                     <div class="upgrade-info-header">
                        <div>
                           <div class="overline mb-1">Corporate Upgrade</div>
                           <div class="upgrade-info-title">Upgrade Processing Record</div>
                        </div>
                        <v-chip small :color="upgradeStatusColor(editeditem.applcorpstatus)" dark>
                           {{ formatUpgradeStatus(editeditem.applcorpstatus) }}
                        </v-chip>
                     </div>

                     <v-row dense>
                        <v-col cols="12" md="4">
                           <v-text-field v-model="upgradeForm.course_date" label="Course Date" type="date" prepend-inner-icon="mdi-calendar-month" dense outlined hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                           <v-text-field v-model="upgradeForm.interview_date" label="Interview Date" type="date" prepend-inner-icon="mdi-account-voice" dense outlined hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                           <v-text-field v-model="upgradeForm.exam_date" label="Exam Date" type="date" prepend-inner-icon="mdi-clipboard-text-outline" dense outlined hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" md="8">
                           <v-textarea v-model="upgradeForm.notes" label="Internal Notes" prepend-inner-icon="mdi-note-text-outline" dense outlined rows="2" hide-details></v-textarea>
                        </v-col>
                        <v-col cols="12" md="4">
                           <v-file-input v-model="upgradeForm.document" label="Support Document" accept=".jpg, .jpeg, .png, .pdf" prepend-icon="" prepend-inner-icon="mdi-paperclip" show-size dense outlined hide-details></v-file-input>
                        </v-col>
                     </v-row>

                     <div class="upgrade-info-actions">
                        <v-btn small color="primary" :loading="savingUpgradeInfo" :disabled="savingUpgradeInfo" @click="saveCorporateUpgradeInfo">
                           <v-icon left small>mdi-content-save-outline</v-icon>
                           Save Upgrade Info
                        </v-btn>
                        <a v-if="editeditem.applcorp_document && editeditem.applcorp_documentpath" class="support-doc-link" :href="'/' + editeditem.applcorp_documentpath + '/' + editeditem.applcorp_document" target="NEW">
                           <v-icon small color="primary">mdi-file-document-outline</v-icon>
                           {{ editeditem.applcorp_document }}
                        </a>
                     </div>
                  </v-alert>

                  <v-row dense class="summary-row">
                     <v-col cols="12" md="4">
                        <div class="summary-tile">
                           <v-icon color="primary">mdi-card-account-details-outline</v-icon>
                           <div>
                              <span>Member ID</span>
                              <strong>{{ formmodelgeneral.memberid || 'Not assigned' }}</strong>
                           </div>
                        </div>
                     </v-col>
                     <v-col cols="12" md="4">
                        <div class="summary-tile">
                           <v-icon color="primary">mdi-account-badge-outline</v-icon>
                           <div>
                              <span>Member Type</span>
                              <strong>{{ selectedMemberTypeLabel }}</strong>
                           </div>
                        </div>
                     </v-col>
                     <v-col cols="12" md="4">
                        <div class="summary-tile">
                           <v-icon :color="selectedStatusIconColor">mdi-shield-check-outline</v-icon>
                           <div>
                              <span>Membership Status</span>
                              <strong>{{ selectedStatusLabel }}</strong>
                           </div>
                        </div>
                     </v-col>
                  </v-row>

                  <v-row dense class="editor-grid">
                     <v-col cols="12" lg="7">
                        <v-card outlined class="member-edit-card editable-card">
                           <div class="section-header">
                              <div>
                                 <div class="overline">Editable Record</div>
                                 <h3>Admin Controls</h3>
                              </div>
                              <v-chip small color="indigo lighten-5" text-color="indigo">
                                 Manual fields
                              </v-chip>
                           </div>

                           <v-row dense class="control-grid">
                              <v-col cols="12" md="6">
                                 <label class="field-label">Member ID</label>
                                 <v-text-field v-model="formmodelgeneral.memberid" placeholder="Assign member ID" prepend-inner-icon="mdi-card-account-details-outline" outlined dense hide-details class="modern-input"></v-text-field>
                                 <small class="field-help">Admin can assign or update this ID.</small>
                              </v-col>
                              <v-col cols="12" md="6">
                                 <label class="field-label">Member Type</label>
                                 <v-select v-model="formmodelgeneral.membertype" :items="memberTypeOptions" prepend-inner-icon="mdi-account-badge-outline" outlined dense hide-details class="modern-input"></v-select>
                              </v-col>
                              <v-col cols="12" md="6">
                                 <label class="field-label">Membership Status</label>
                                 <v-select v-model="formmodelgeneral.memberstatus" :items="memberStatusOptions" prepend-inner-icon="mdi-shield-account-outline" outlined dense hide-details class="modern-input"></v-select>
                              </v-col>
                              <v-col cols="12" md="3">
                                 <label class="field-label">LPBM Code</label>
                                 <v-select v-model="formmodelgeneral.lpbmcode" :items="lpbmCodeOptions" outlined dense clearable hide-details class="modern-input"></v-select>
                              </v-col>
                              <v-col cols="12" md="3">
                                 <label class="field-label">LPBM No.</label>
                                 <v-text-field v-model="formmodelgeneral.lpbmno" outlined dense hide-details class="modern-input"></v-text-field>
                              </v-col>
                           </v-row>
                        </v-card>
                     </v-col>

                     <v-col cols="12" lg="5">
                        <v-card outlined class="member-edit-card system-date-card timeline-card">
                           <div class="section-header">
                              <div>
                                 <div class="overline">System Controlled</div>
                                 <h3>Audit Timeline</h3>
                              </div>
                              <v-chip small color="grey lighten-3" text-color="grey darken-3">
                                 Read only
                              </v-chip>
                           </div>

                           <div class="timeline-field">
                              <v-icon small color="blue">mdi-file-sign</v-icon>
                              <div>
                                 <span>Date Applied</span>
                                 <strong>{{ formmodelgeneral.dateapplied || '-' }}</strong>
                              </div>
                           </div>
                           <div class="timeline-field">
                              <v-icon small color="green">mdi-check-decagram-outline</v-icon>
                              <div>
                                 <span>Date Approved</span>
                                 <strong>{{ formmodelgeneral.dateapproved || '-' }}</strong>
                              </div>
                           </div>
                           <div class="timeline-field">
                              <v-icon small color="deep-purple">mdi-credit-card-check-outline</v-icon>
                              <div>
                                 <span>Date Payment</span>
                                 <strong>{{ formmodelgeneral.datepayment || '-' }}</strong>
                              </div>
                           </div>
                           <div class="timeline-field">
                              <v-icon small color="orange">mdi-calendar-check-outline</v-icon>
                              <div>
                                 <span>Date Valid</span>
                                 <strong>{{ formmodelgeneral.datevalid || '-' }}</strong>
                              </div>
                           </div>

                           <v-alert dense text type="info" class="mt-3 mb-0">
                              Payment and validity dates are updated by approval/payment flows.
                           </v-alert>
                        </v-card>
                     </v-col>
                  </v-row>
               </div>
            </v-tab-item>
            <v-tab-item key="T2">
               <v-row dense>
                  <v-col cols="9">
                     <v-form v-model="isvaliddetails">
                        <v-jsf v-model="formmodel" :schema="formschema" :options="formoptions"/>
                     </v-form>
                  </v-col>
                  <v-col cols="3" class="text-center pa-4">
                     <v-avatar size="180">
                        <v-img
                           :src="previewphoto"
                           :alt="formmodel.sectdetails.fullname"
                        />
                     </v-avatar>
                     <v-file-input ref="photofile" prepend-icon="mdi-camera" show-size v-model="photofile" accept="image/png, image/jpeg, image/bmp" placeholder="Pick a photo"/>
                  </v-col>
               </v-row>
            </v-tab-item>
            <v-tab-item key="T3">
               <table-qual-edu :key="sectionKey('qualedu')" ref="qualedu" v-on:QualEduMounted="onQualEduMounted"></table-qual-edu>
               <v-divider v-if="(editeditem) ? (editeditem.membertype !== 'STU') : false"></v-divider>
               <table-qual-pro :key="sectionKey('qualpro')" ref="qualpro" v-if="(editeditem) ? (editeditem.membertype !== 'STU') : false" v-on:QualProMounted="onQualProMounted"></table-qual-pro>
               <v-divider v-if="(editeditem) ? (editeditem.membertype === 'STU') : false"></v-divider>
               <table-qual-stu :key="sectionKey('qualstu')" ref="qualstu" v-if="(editeditem) ? (editeditem.membertype === 'STU') : false" v-on:QualStuMounted="onQualStuMounted"></table-qual-stu>
            </v-tab-item>
            <v-tab-item key="T4" v-if="(editeditem) ? (editeditem.membertype !== 'STU') : false">
               <table-emp-exp :key="sectionKey('empexp')" ref="empexp" v-on:EmpExpMounted='onEmpExpMounted'></table-emp-exp>
               <v-divider></v-divider>
               <table-emp-cat :key="sectionKey('empcat')" ref="empcat" v-on:EmpCatUpdated="onEmpCatUpdated" v-on:EmpCatMounted="onEmpCatMounted"></table-emp-cat>
            </v-tab-item>
            <v-tab-item key="T5" v-if="(editeditem) ? (editeditem.membertype === 'COR') : false">
               <table-corp-exp :key="sectionKey('corpexp')" ref="corpexp" v-on:CorpExpCompleted="onCorpExpCompleted" v-on:CorpExpMounted="onCorpExpMounted"></table-corp-exp>
            </v-tab-item>
            <v-tab-item key="T6">
               <table-decl-read-only :key="sectionKey('decl')" ref="decl" admin-mode v-on:DeclMounted="onDeclMounted"></table-decl-read-only>
            </v-tab-item>
            <v-tab-item key="T7">
               <table-payment-read-only :key="sectionKey('payment')" ref="payment" v-on:PaymentMounted="onPaymentMounted"></table-payment-read-only>
            </v-tab-item>
         </v-tabs-items>
         <v-snackbar v-model="saveFeedback.show" :color="saveFeedback.color" timeout="3500" right bottom>
            {{ saveFeedback.message }}
            <template v-slot:action="{ attrs }">
               <v-btn text v-bind="attrs" @click="saveFeedback.show = false">Close</v-btn>
            </template>
         </v-snackbar>
      </v-card>
   </v-dialog>
</template>

<script>
const axios = require('axios')
import VJsf from '@koumoul/vjsf/lib/VJsf.js'
import '@koumoul/vjsf/lib/VJsf.css'
import '@koumoul/vjsf/lib/deps/third-party.js'
import PersonalDetailsModel from '../Forms/PersonalDetailsModel.js'
import PersonalDetailsSchema from '../Forms/PersonalDetailsSchema.js'
import MemberGeneralModel from '../Forms/MemberGeneralModel.js'
import MemberGeneralSchema from '../Forms/MemberGeneralSchema.js'
import GeneralOptions from '../Forms/GeneralOptions.js'
import TableQualEdu from '../Tables/TableQualEdu.vue'
import TableQualPro from '../Tables/TableQualPro.vue'
import TableQualStu from '../Tables/TableQualStu.vue'
import TableEmpExp from '../Tables/TableEmpExp.vue'
import TableEmpCat from '../Tables/TableEmpCat.vue'
import TableCorpExp from '../Tables/TableCorpExp.vue'
import TableDeclReadOnly from '../Tables/TableDeclReadOnly.vue'
import TablePaymentReadOnly from '../Tables/TablePaymentReadOnly.vue'

export default {
   name: 'DialogMemberEdit',
   props: {},
   components: {
      TableQualEdu,
      TableQualPro,
      TableQualStu,
      TableEmpExp,
      TableEmpCat,
      TableCorpExp,
      TableDeclReadOnly,
      TablePaymentReadOnly,
      VJsf,
   },
   data: () => ({
      user: Object,
      recid: 0,
      formmodel: PersonalDetailsModel,
      formschema: PersonalDetailsSchema,
      formoptions: GeneralOptions,
      formmodelgeneral: MemberGeneralModel,
      formschemageneral: MemberGeneralSchema,
      editeditem: null,
      isvalidgeneral: false,
      isvaliddetails: false,
      dlgedit: false,
      tab: 0,
      photofile: null,
      previewphoto: null,
      savingMember: false,
      saveFeedback: {
         show: false,
         color: 'success',
         message: '',
      },
      savingUpgradeInfo: false,
      upgradeForm: {
         course_date: '',
         interview_date: '',
         exam_date: '',
         notes: '',
         document: null,
      },
      memberTypeOptions: [
         { text: 'Associate Member', value: 'ASC' },
         { text: 'Student Member', value: 'STU' },
         { text: 'Graduate Member', value: 'GRA' },
         { text: 'Corporate Member', value: 'COR' },
         { text: 'Fellow Member', value: 'FEL' },
         { text: 'Honorary Member', value: 'HON' },
         { text: 'Patron', value: 'PAT' },
      ],
      memberStatusOptions: [
         { text: 'Applying', value: 0 },
         { text: 'Pending Approval', value: 1 },
         { text: 'Pending Payment', value: 2 },
         { text: 'Active', value: 3 },
         { text: 'Suspended', value: 4 },
         { text: 'Retired', value: 5 },
         { text: 'Deceased', value: 6 },
         { text: 'Struck-Off', value: 7 },
         { text: 'Active - Not Good Standing', value: 8 },
      ],
      lpbmCodeOptions: ['A', 'B'],
   }),
   computed: {
      isCorporateUpgradePending() {
         return this.editeditem && this.editeditem.applcorpstatus === 1
      },

      selectedMemberTypeLabel() {
         var option = this.memberTypeOptions.find(item => item.value === this.formmodelgeneral.membertype)
         return option ? option.text : 'Member type not set'
      },

      selectedStatusLabel() {
         var option = this.memberStatusOptions.find(item => Number(item.value) === Number(this.formmodelgeneral.memberstatus))
         return option ? option.text : 'Status not set'
      },

      selectedStatusColor() {
         var status = Number(this.formmodelgeneral.memberstatus)
         if (status === 3) return 'green darken-1'
         if (status === 2) return 'orange darken-1'
         if (status === 1) return 'blue darken-1'
         if ([4, 7, 8].includes(status)) return 'red darken-1'
         return 'blue-grey darken-1'
      },

      selectedStatusIconColor() {
         var status = Number(this.formmodelgeneral.memberstatus)
         if (status === 3) return 'green'
         if (status === 2) return 'orange'
         if (status === 1) return 'blue'
         if ([4, 7, 8].includes(status)) return 'red'
         return 'blue-grey'
      },

      lpbmDisplay() {
         var value = [this.formmodelgeneral.lpbmcode, this.formmodelgeneral.lpbmno].filter(Boolean).join(' ')
         return value || 'LPBM not assigned'
      }
   },
   watch: {
      'formmodel.sectdetails.icpassport': function (newval) {
         const formatted = this.formatIcPassport(newval)
         if (formatted !== newval) {
            this.formmodel.sectdetails.icpassport = formatted
         }
      },
   },
   methods: {
      sectionKey(section) {
         return section + '-' + (this.editeditem && this.editeditem.userid ? this.editeditem.userid : 'empty')
      },

      onPaymentMounted() {
         if (this.editeditem) {
            this.$refs.payment.setuserid(this.editeditem.userid)
         }
      },

      onDeclMounted() {
         if (this.editeditem) {
            this.$refs.decl.setuserid(this.editeditem.userid)
         }
      },

      onCorpExpCompleted() {
         console.log('CorpExp completed')
      },

      onCorpExpMounted() {
         if (this.editeditem) {
            this.$refs.corpexp.setuserid(this.editeditem.userid)
         }
      },

      onEmpCatMounted() {
         if (this.editeditem) {
            this.$refs.empcat.setuserid(this.editeditem.userid)
         }
      },

      onEmpCatUpdated() {

      },

      onEmpExpMounted() {
         if (this.editeditem) {
            this.$refs.empexp.setuserid(this.editeditem.userid)
         }
      },

      onQualStuMounted() {
         if (this.editeditem) {
            this.$refs.qualstu.setuserid(this.editeditem.userid)
         }
      },

      onQualProMounted() {
         if (this.editeditem) {
            this.$refs.qualpro.setuserid(this.editeditem.userid)
         }
      },

      onQualEduMounted() {
         if (this.editeditem) {
            this.$refs.qualedu.setuserid(this.editeditem.userid)
         }
      },

      setid(pID) {
         this.recid = pID
         this.tab = 0
         this.loaddata()
      },

      loaddata() {
         var targetPath = '/admin/member/' + this.recid

         axios.get(targetPath)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.editeditem = rtn.data
                  if (this.editeditem) {
                     this.loadform(this.editeditem)
                     this.dlgedit = true
                  }
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      formatdate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY h:mm:ss A')
      },

      formatShortDate(e) {
         return this.$moment(new Date(e)).format('DD/MM/YYYY')
      },

      formatUpgradeStatus(e) {
         if (e === 1) return 'Pending Review'
         if (e === 2) return 'Approved'
         if (e === 3) return 'Rejected'
         if (e === 4) return 'Incomplete - Waiting Resubmission'
         return 'Not Submitted'
      },

      upgradeStatusColor(e) {
         if (e === 1) return 'orange darken-1'
         if (e === 2) return 'green darken-1'
         if (e === 3) return 'red darken-1'
         if (e === 4) return 'deep-orange darken-1'
         return 'grey darken-1'
      },

      loadform(pItem) {
         // general
         this.formmodelgeneral.memberid = (pItem.memberid) ? pItem.memberid : ''
         this.formmodelgeneral.lpbmcode = (pItem.lpbmcode) ? pItem.lpbmcode : ''
         this.formmodelgeneral.lpbmno = (pItem.lpbmno) ? pItem.lpbmno : ''
         this.formmodelgeneral.membertype = (pItem.membertype) ? pItem.membertype : ''
         this.formmodelgeneral.memberstatus = (pItem.memberstatus !== null && pItem.memberstatus !== undefined && pItem.memberstatus !== '') ? Number(pItem.memberstatus) : ''
         this.formmodelgeneral.dateapplied = (pItem.dateapplied) ? this.formatdate(pItem.dateapplied) : ''
         this.formmodelgeneral.dateapproved = (pItem.dateapproved) ? this.formatdate(pItem.dateapproved) : ''
         this.formmodelgeneral.datepayment = (pItem.datepayment) ? this.formatdate(pItem.datepayment) : ''
         this.formmodelgeneral.datevalid = (pItem.datevalid) ? this.formatdate(pItem.datevalid) : ''

         this.formmodel.sectdetails.fullname = pItem.fullname
         this.formmodel.sectdetails.gender = pItem.gender
         this.formmodel.sectdetails.nationality = pItem.nationality
         this.formmodel.sectdetails.race = pItem.race
         this.formmodel.sectdetails.religion = pItem.religion
         this.formmodel.sectdetails.icpassport = this.formatIcPassport(pItem.icpassport)
         this.formmodel.sectdetails.dob = pItem.dob
         this.formmodel.sectdetails.pob = pItem.pob
         this.formmodel.sectdetails.contactmobile = pItem.contactmobile
         this.formmodel.sectdetails.contactemail = pItem.contactemail

         this.formmodel.secthome.homestreet = pItem.homestreet
         this.formmodel.secthome.homepostcode = pItem.homepostcode
         this.formmodel.secthome.homecity = pItem.homecity
         this.formmodel.secthome.homedistrict = pItem.homedistrict
         this.formmodel.secthome.homestate = pItem.homestate
         this.formmodel.secthome.homecountry = pItem.homecountry
         this.formmodel.secthome.homephone = pItem.homephone

         this.formmodel.sectwork.workcompany = pItem.workcompany
         this.formmodel.sectwork.workjobtitle = pItem.workjobtitle
         this.formmodel.sectwork.workdept = pItem.workdept
         this.formmodel.sectwork.workposition = pItem.workposition
         this.formmodel.sectwork.workstreet = pItem.workstreet
         this.formmodel.sectwork.workpostcode = pItem.workpostcode
         this.formmodel.sectwork.workcity = pItem.workcity
         this.formmodel.sectwork.workdistrict = pItem.workdistrict
         this.formmodel.sectwork.workstate = pItem.workstate
         this.formmodel.sectwork.workcountry = pItem.workcountry
         this.formmodel.sectwork.workphone = pItem.workphone
         this.formmodel.sectwork.workfax = pItem.workfax
         this.formmodel.sectwork.workemail = pItem.workemail

         this.formmodel.sectcontactpref.prefercontacthome = pItem.prefercontacthome
         this.formmodel.sectcontactpref.prefercontactwork = pItem.prefercontactwork
         this.formmodel.sectcontactpref.prefercontactemail = pItem.prefercontactemail

         this.previewphoto = pItem.userid ? ('/member/photo/' + pItem.userid + '?v=' + (pItem.updated_at ? new Date(pItem.updated_at).getTime() : Date.now())) : '/images/miplogo-300x300.png'

         this.upgradeForm.course_date = this.toInputDate(pItem.applcorp_course_date)
         this.upgradeForm.interview_date = this.toInputDate(pItem.applcorp_interview_date)
         this.upgradeForm.exam_date = this.toInputDate(pItem.applcorp_exam_date)
         this.upgradeForm.notes = pItem.applcorp_notes || ''
         this.upgradeForm.document = null

      },

      closeEdit() {
         this.dlgedit = false
         this.tab = 0
         this.editeditem = null
      },

      approvemember() {
         var targetPath = '/admin/member/approve'
         var data = {
            userid: this.editeditem.userid
         }
         axios.post(targetPath, data)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.$emit('MembershipApproved')
                  this.closeEdit()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      },

      toInputDate(e) {
         return e ? this.$moment(new Date(e)).format('YYYY-MM-DD') : ''
      },

      formatIcPassport(value) {
         const current = String(value || '').trim()
         if (/[A-Za-z]/.test(current)) {
            return current
         }

         const digits = current.replace(/\D/g, '').slice(0, 12)
         if (digits.length <= 6) {
            return digits
         }
         if (digits.length <= 8) {
            return `${digits.slice(0, 6)}-${digits.slice(6)}`
         }
         return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-${digits.slice(8)}`
      },

      fieldValue(value) {
         return value === null || value === undefined ? '' : value
      },

      approveCorporateUpgrade() {
         axios.post('/admin/member/upgrade-corporate/approve', {
            userid: this.editeditem.userid
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.$emit('MembershipUpdated')
               this.closeEdit()
            } else if (resp.data) {
               alert(resp.data.error)
            }
         })
      },

      rejectCorporateUpgrade() {
         axios.post('/admin/member/upgrade-corporate/reject', {
            userid: this.editeditem.userid
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.$emit('MembershipUpdated')
               this.closeEdit()
            } else if (resp.data) {
               alert(resp.data.error)
            }
         })
      },

      openCorporateInfo() {
         if (!this.editeditem || !this.editeditem.userid) {
            return
         }
         window.location.href = '/admin/member/upgrade-corporate/' + this.editeditem.userid
      },

      notifyDecline() {
         if (!this.editeditem || !this.editeditem.userid) {
            return
         }

         if (!confirm('Decline this application and notify the member?')) {
            return
         }

         axios.post('/admin/member/email/decline', {
            userid: this.editeditem.userid
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               alert(resp.data.message || 'Application declined.')
               this.$emit('MembershipUpdated')
               this.closeEdit()
            } else if (resp.data) {
               alert(resp.data.error)
            }
         })
      },

      notifyIncomplete() {
         if (!this.editeditem || !this.editeditem.userid) {
            return
         }

         axios.post('/admin/member/email/incomplete', {
            userid: this.editeditem.userid
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               alert(resp.data.message || 'Application marked incomplete.')
               this.$emit('MembershipUpdated')
               this.closeEdit()
            } else if (resp.data) {
               alert(resp.data.error)
            }
         })
      },

      saveCorporateUpgradeInfo() {
         const data = new FormData()
         data.append('userid', this.editeditem.userid)
         data.append('course_date', this.upgradeForm.course_date)
         data.append('interview_date', this.upgradeForm.interview_date)
         data.append('exam_date', this.upgradeForm.exam_date)
         data.append('notes', this.upgradeForm.notes)
         if (this.upgradeForm.document) {
            data.append('document', this.upgradeForm.document)
         }

         this.savingUpgradeInfo = true
         axios.post('/admin/member/upgrade-corporate/update-info', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.editeditem = resp.data.data
               this.loadform(this.editeditem)
               this.$emit('MembershipUpdated')
            } else if (resp.data) {
               alert(resp.data.error)
            }
         })
         .finally(() => {
            this.savingUpgradeInfo = false
         })
      },

      updatemember() {
         if (this.savingMember || !this.editeditem || !this.editeditem.userid) {
            return
         }

         var targetPath = "/admin/member/update"

         const data = new FormData()
         data.append('userid', this.editeditem.userid)
         data.append('fullname', this.fieldValue(this.formmodel.sectdetails.fullname))
         data.append('gender', this.fieldValue(this.formmodel.sectdetails.gender))
         data.append('nationality', this.fieldValue(this.formmodel.sectdetails.nationality))
         data.append('race', this.fieldValue(this.formmodel.sectdetails.race))
         data.append('religion', this.fieldValue(this.formmodel.sectdetails.religion))
         data.append('icpassport', this.formatIcPassport(this.formmodel.sectdetails.icpassport))
         data.append('dob', this.fieldValue(this.formmodel.sectdetails.dob))
         data.append('pob', this.fieldValue(this.formmodel.sectdetails.pob))
         data.append('contactmobile', this.fieldValue(this.formmodel.sectdetails.contactmobile))
         data.append('contactemail', this.fieldValue(this.formmodel.sectdetails.contactemail))
         data.append('homestreet', this.fieldValue(this.formmodel.secthome.homestreet))
         data.append('homepostcode', this.fieldValue(this.formmodel.secthome.homepostcode))
         data.append('homecity', this.fieldValue(this.formmodel.secthome.homecity))
         data.append('homedistrict', this.fieldValue(this.formmodel.secthome.homedistrict))
         data.append('homestate', this.fieldValue(this.formmodel.secthome.homestate))
         data.append('homecountry', this.fieldValue(this.formmodel.secthome.homecountry))
         data.append('homephone', this.fieldValue(this.formmodel.secthome.homephone))
         data.append('workcompany', this.fieldValue(this.formmodel.sectwork.workcompany))
         data.append('workjobtitle', this.fieldValue(this.formmodel.sectwork.workjobtitle))
         data.append('workdept', this.fieldValue(this.formmodel.sectwork.workdept))
         data.append('workposition', this.fieldValue(this.formmodel.sectwork.workposition))
         data.append('workstreet', this.fieldValue(this.formmodel.sectwork.workstreet))
         data.append('workpostcode', this.fieldValue(this.formmodel.sectwork.workpostcode))
         data.append('workcity', this.fieldValue(this.formmodel.sectwork.workcity))
         data.append('workdistrict', this.fieldValue(this.formmodel.sectwork.workdistrict))
         data.append('workstate', this.fieldValue(this.formmodel.sectwork.workstate))
         data.append('workcountry', this.fieldValue(this.formmodel.sectwork.workcountry))
         data.append('workphone', this.fieldValue(this.formmodel.sectwork.workphone))
         data.append('workfax', this.fieldValue(this.formmodel.sectwork.workfax))
         data.append('workemail', this.fieldValue(this.formmodel.sectwork.workemail))
         data.append('prefercontacthome', this.fieldValue(this.formmodel.sectcontactpref.prefercontacthome))
         data.append('prefercontactwork', this.fieldValue(this.formmodel.sectcontactpref.prefercontactwork))
         data.append('prefercontactemail', this.fieldValue(this.formmodel.sectcontactpref.prefercontactemail))

         data.append('memberid', this.fieldValue(this.formmodelgeneral.memberid))
         data.append('memberstatus', this.fieldValue(this.formmodelgeneral.memberstatus))
         data.append('membertype', this.fieldValue(this.formmodelgeneral.membertype))
         data.append('lpbmcode', this.fieldValue(this.formmodelgeneral.lpbmcode))
         data.append('lpbmno', this.fieldValue(this.formmodelgeneral.lpbmno))

         // photo
         if (this.photofile) {
            data.append('photolink', this.photofile)
         }

         // for (var value of data.values()) {
         //    console.log(value);
         // }

         this.savingMember = true
         axios.post(targetPath, data, {
            headers: {
               'Content-Type': 'multipart/form-data'
            }
         })
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  if (rtn.data) {
                     this.editeditem = rtn.data
                     this.loadform(this.editeditem)
                  }
                  this.saveFeedback = {
                     show: true,
                     color: 'success',
                     message: rtn.message || 'Membership details updated.'
                  }
                  this.$emit('MembershipUpdated')
               } else {
                  this.saveFeedback = {
                     show: true,
                     color: 'error',
                     message: rtn.error || 'Unable to save membership details.'
                  }
               }
            }
         })
         .catch((error) => {
            this.saveFeedback = {
               show: true,
               color: 'error',
               message: (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Unable to save membership details.'
            }
         })
         .finally(() => {
            this.savingMember = false
         })
      },
   },
   mounted() {
      console.log('DialogMemberEdit mounted')
      this.user = this.$page.user
      // console.log(this.$refs.qualedu)
   }
}
</script>

<style scoped>
.member-edit-dialog {
   background: #f7f9fc !important;
}

.member-edit-toolbar {
   background: linear-gradient(120deg, #0f766e 0%, #0f5f9e 48%, #1d4ed8 100%) !important;
   box-shadow: 0 10px 26px rgba(15, 23, 42, .18) !important;
}

.member-edit-toolbar ::v-deep .v-toolbar__title {
   font-weight: 700;
   letter-spacing: 0;
}

.member-edit-toolbar ::v-deep .v-btn {
   letter-spacing: .04em;
}

.member-edit-tabs {
   background: linear-gradient(90deg, #0f766e 0%, #1769aa 46%, #1d4ed8 100%) !important;
   box-shadow: inset 0 -1px 0 rgba(255,255,255,.12);
}

.member-edit-tabs ::v-deep .v-tabs-bar {
   background: transparent !important;
}

.member-edit-tabs ::v-deep .v-tab {
   color: rgba(255,255,255,.72) !important;
   font-size: 13px;
   font-weight: 700;
   letter-spacing: .06em;
   opacity: 1;
}

.member-edit-tabs ::v-deep .v-tab--active {
   background: rgba(255,255,255,.12);
   color: #fff !important;
   opacity: 1;
}

.member-edit-tabs ::v-deep .v-tabs-slider {
   background-color: #7dd3fc !important;
   height: 3px;
}

.member-edit-page {
   background: linear-gradient(180deg, #eef4fb 0%, #f7f9fc 42%, #f7f9fc 100%);
   min-height: calc(100vh - 112px);
   padding: 18px;
}

.member-editor-hero {
   align-items: center;
   background: linear-gradient(120deg, #0f766e 0%, #1769aa 48%, #234fd0 100%);
   border-radius: 8px;
   box-shadow: 0 16px 36px rgba(15, 23, 42, .14);
   color: #fff;
   display: flex;
   justify-content: space-between;
   gap: 18px;
   margin-bottom: 16px;
   overflow: hidden;
   padding: 24px;
   position: relative;
}

.member-editor-hero::after {
   background: rgba(255, 255, 255, .08);
   border-radius: 999px;
   content: "";
   height: 220px;
   position: absolute;
   right: -70px;
   top: -92px;
   width: 220px;
}

.hero-main,
.hero-actions,
.hero-subline,
.hero-chips {
   align-items: center;
   display: flex;
}

.hero-main {
   gap: 16px;
   min-width: 0;
   position: relative;
   z-index: 1;
}

.hero-avatar {
   border: 3px solid rgba(255, 255, 255, .85);
   box-shadow: 0 12px 28px rgba(15, 23, 42, .18);
}

.hero-copy {
   min-width: 0;
}

.hero-overline {
   color: rgba(255, 255, 255, .82) !important;
}

.hero-copy h2 {
   color: #fff;
   font-size: 28px;
   font-weight: 800;
   line-height: 1.1;
   margin: 0 0 6px;
}

.hero-subline {
   color: rgba(255, 255, 255, .9);
   flex-wrap: wrap;
   font-size: 13px;
   gap: 10px;
}

.hero-subline span:not(:last-child)::after {
   color: rgba(255, 255, 255, .45);
   content: "|";
   margin-left: 10px;
}

.hero-chips {
   flex-wrap: wrap;
   gap: 8px;
   margin-top: 12px;
}

.hero-actions {
   gap: 10px;
   position: relative;
   z-index: 1;
}

.upgrade-info-panel {
   background: #f8fbff !important;
   border: 1px solid #cfe3ff;
   border-radius: 8px;
   margin-bottom: 16px;
}

.upgrade-info-header,
.section-header,
.upgrade-info-actions {
   align-items: center;
   display: flex;
   justify-content: space-between;
   gap: 12px;
}

.upgrade-info-header {
   margin-bottom: 14px;
}

.upgrade-info-title,
.section-header h3 {
   color: #0f172a;
   font-size: 18px;
   font-weight: 700;
   line-height: 1.2;
   margin: 0;
}

.member-edit-card {
   background: #fff;
   border: 1px solid #dde6f1 !important;
   border-radius: 8px;
   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
   padding: 20px;
}

.section-header {
   border-bottom: 1px solid #edf1f7;
   margin-bottom: 16px;
   padding-bottom: 12px;
}

.system-date-card {
   height: 100%;
}

.summary-row {
   margin-bottom: 10px;
}

.summary-tile {
   align-items: center;
   background: #fff;
   border: 1px solid #e1e8f2;
   border-radius: 8px;
   box-shadow: 0 10px 26px rgba(15, 23, 42, .05);
   display: flex;
   gap: 12px;
   min-height: 76px;
   padding: 16px;
}

.summary-tile span,
.field-label {
   color: #64748b;
   display: block;
   font-size: 11px;
   font-weight: 800;
   letter-spacing: .06em;
   margin-bottom: 5px;
   text-transform: uppercase;
}

.summary-tile strong {
   color: #0f172a;
   display: block;
   font-size: 15px;
   font-weight: 800;
   line-height: 1.25;
}

.editor-grid {
   align-items: stretch;
}

.control-grid {
   row-gap: 12px;
}

.field-help {
   color: #64748b;
   display: block;
   font-size: 11px;
   margin-top: 6px;
}

.modern-input ::v-deep .v-input__slot {
   background: #fbfdff !important;
   min-height: 44px !important;
}

.timeline-card {
   background: linear-gradient(180deg, #fff 0%, #fbfdff 100%);
}

.timeline-field {
   align-items: flex-start;
   border-left: 2px solid #dce7f4;
   border-bottom: 0;
   display: flex;
   justify-content: flex-start;
   gap: 12px;
   margin-left: 8px;
   padding: 2px 0 18px 16px;
   position: relative;
}

.timeline-field::before {
   background: #fff;
   border: 2px solid #c7d7ea;
   border-radius: 999px;
   content: "";
   height: 10px;
   left: -6px;
   position: absolute;
   top: 7px;
   width: 10px;
}

.timeline-field:last-of-type {
   padding-bottom: 4px;
}

.timeline-field span {
   color: #64748b;
   font-size: 12px;
   font-weight: 700;
   letter-spacing: .04em;
   text-transform: uppercase;
}

.timeline-field strong {
   color: #0f172a;
   display: block;
   font-size: 14px;
   font-weight: 700;
   line-height: 1.35;
   text-align: left;
}

.support-doc-link {
   align-items: center;
   display: inline-flex;
   font-size: 13px;
   gap: 6px;
   min-width: 0;
   overflow-wrap: anywhere;
}

.upgrade-info-actions {
   border-top: 1px solid #d9eaff;
   margin-top: 14px;
   padding-top: 12px;
}

@media (max-width: 960px) {
   .member-editor-hero {
      align-items: flex-start;
      flex-direction: column;
   }

   .hero-actions {
      width: 100%;
   }
}
</style>
